import React from "react";
import { useEffect } from "react";
import { CMSPath } from "../../../config/constant";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { makeSpaBooking } from "../../../action/spaBooking";
import { formatDateAsDateFormat } from "./spaBooking3";

const serviceDetails = (id, data) => {
  return data.find((services) => services.id === Number(id));
};

function SpaBooking3summary(props) {
  const { t } = props;

  const getSelectedSeviceField=(fieldName)=>{

	 const selectedService=props.serviceData.services.find(service=>String(service.id)==props.selectedServiceId)
	 return selectedService[fieldName]
  }

  useEffect(() => {
    console.log("props in sb summary", props);
  });


  const handleNext = () => {
    // prepare payload
 
	// const payload={};

    const payload = {

        dateTime: props.selectedTechnicianDetails.availableDate,
        serviceId: JSON.parse(props.selectedServiceId),
        spaLocationId: props.spaLocationId,
        technicianId: props.selectedTechnicianDetails.technicianId,
        guestNotes: "", // Additional notes or guest comment
        requestedType: "NO_PREFERENCE",
        addOnServiceId: [],
    };
    console.log("makespabooking payload", payload);
	props.handleMakeReservation(payload)
  };

  useEffect(() => {
    console.log("SpaBooking3summary", props);
    console.log(
      serviceDetails(props.selectedServiceId, props.serviceData.services)
    );
  });
  return (
    <>
      <div>
        {/* <header class="inner-pages subpages">

 			<div class="heading align-center">
				<p class="bold">Spa name</p>
			</div>
		</header> */}
        <section class="widgets spa-listing spa-details">
          <div class="widget-header">
            {props.currentWidgetObj.widgetHeaderImageUrl && (
              <div class="widget-header-img">
                <img
                  src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                  alt={props.currentWidgetObj.displayName}
                />
              </div>
            )}
            <div class="widget-header-title">{t("spaBooking.summary")}</div>
          </div>

          <div class="widgets">
            <div class="row margin-bottom-2">
              <div class="row">
                <div class="col">
                  <div class="detail-body stay-body">
                    <form>
                      <div class="stay-info">
                        <div class="stay-arrival">
                          <div class="heading">Date and Time</div>
                          <div class="body">
                            <p>
                              {
							  formatDateAsDateFormat(
							  new Date(
                                props.selectedTechnicianDetails.availableDate
                              ))}
                            </p>
                          </div>
                        </div>
                       
                      </div>



                      
                      <div class="stay-info-details">
                        <div class="stay-info-body">
                          <p class="heading">Location</p>
                          <p>
                            Val des Pitons La Baie de Silence, Soufriere, Saint
                            Lucia
                          </p>
                        </div>
                      </div>
                      <div class="form-row spa-summary">
                        <p class="heading">Details</p>
                        <label>
                          Treatment <span>{props.serviceData.name}</span>
                        </label>
                        <label>
                          Duration{" "}
                          <span>
                            {
                              serviceDetails(
                                props.selectedServiceId,
                                props.serviceData.services
                              ).duration
                            }{" "}
                            Mins
                          </span>
                        </label>
                        <label>
                          Therapist{" "}
                          <span>
                            {props.selectedTechnicianDetails.technicianName}
                          </span>
                        </label>
                    
                      </div>
                      <div class="form-row price-total">
                        <label>
                          Total Price
                          <span>
                            USD{" "}
                            {
                            
							  `${serviceDetails(
                                props.selectedServiceId,
                                props.serviceData.services
                              ).price}${(props.selectedTechnicianDetails.technicianPrice)>0?` + ${props.selectedTechnicianDetails.technicianPrice}=${serviceDetails(
                                props.selectedServiceId,
                                props.serviceData.services
                              ).price+props.selectedTechnicianDetails.technicianPrice}`:''}`
                            }
                          </span>
                        </label>
                      </div>
                    </form>



                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-controls">
                  <button onClick={handleNext}>
                    {t("spaBooking.make_reservation")}
                  </button>
                  <button onClick={props.handleBack}>{t("spaBooking.edit")}</button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <script type="text/javascript" src="js/jquery-3.3.1.min.js"></script>
        <script type="text/javascript" src="js/framework.js"></script>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    currentWidgetObj: state.store.sideNavBar.currentWidget,
  };
};

export default connect(mapStateToProps)(
  withTranslation("translations")(SpaBooking3summary)
);

// continue - do api calling to
//date and time accordingly

// Location not there
//cancellatoin, booking no?
